import React, { useEffect, useState } from 'react';
import { useObservable } from 'react-use-observable';

import { App, Modal, Typography } from 'antd';

import { useSaveTerms } from 'v2/hooks/useSaveTerms';
import eduzzAccountsService from 'v2/services/eduzzAccount';

const TERMS_OF_USE_URL = 'https://eduzz.com/termos';

export const ModalTerms = () => {
  const { message } = App.useApp();
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  const [accesses] = useObservable(() => eduzzAccountsService.getAccesses(), []);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const saveAcceptTermsMutation = useSaveTerms({
    onSuccess: () => {
      message.success('Aceite dos termos salvo com sucesso');
      setIsOpen(false);
    },
    onError: () => {
      message.error('Erro ao aceitar os termos');
      setIsLoading(false);
    }
  });

  const saveRefuseTermosMutation = useSaveTerms({
    onSettled: () => {
      eduzzAccountsService.logout();
    }
  });

  useEffect(() => {
    if (!user || user.is_support || !accesses) return;
    const canApproveNewTerms = (accesses ?? []).some(
      item => item.id === user?.id && item.isMe === true && item.termsAcceptance == false
    );
    setIsOpen(canApproveNewTerms);
  }, [user, accesses]);

  const handleRefuse = async () => {
    setIsLoading(true);
    await saveRefuseTermosMutation.mutateAsync(false);
  };

  const handleAccept = async () => {
    setIsLoading(true);
    await saveAcceptTermsMutation.mutateAsync(true);
  };

  return (
    <Modal
      open={isOpen}
      zIndex={2000}
      width={900}
      keyboard={false}
      closable={false}
      title='Atualizamos nossos Termos de Uso'
      onCancel={handleRefuse}
      onOk={handleAccept}
      cancelText='Recusar e sair'
      okText='Aceitar e prosseguir'
      confirmLoading={isLoading}
      cancelButtonProps={{ type: 'text', disabled: isLoading }}
    >
      <div className='flex flex-col gap-4'>
        <Typography.Paragraph className='mb-0'>
          Estamos atualizando nossos Termos de Uso e, para continuar utilizando nossos serviços, a partir desta data
          você deve concordar com estas revisões.
        </Typography.Paragraph>
        <Typography.Link href={TERMS_OF_USE_URL} target='_blank' rel='noopener noreferrer' className='self-center'>
          Novos Termos de Uso da Eduzz
        </Typography.Link>
        <Typography.Paragraph className='mb-0'>
          Em caso de dúvidas entre em contato com o nosso Canal de Atendimento em:
        </Typography.Paragraph>
        <Typography.Link href='mailto:suporte@eduzz.com' className='self-center'>
          suporte@eduzz.com
        </Typography.Link>
      </div>
    </Modal>
  );
};
